<template>
  <div>
    <button type="button" class="btn btn-light btn-outline-primary" @click="show=true" title="Add Transaction">
      <i class="bi bi-plus-circle me-md-2"></i>
      <span class="d-none d-md-inline-block">Add Transaction</span>
    </button>
    <app-modal :modal-in="show" @close="show=false" :dynamic="true" modal-class="modal-xl">
      <template #header>Add Transaction</template>
      <edit-transaction :transaction="{}" @saved="handleSaved" />
    </app-modal>
  </div>
</template>

<script setup>
import AppModal from "@/app/components/Utils/AppModal.vue";
import { ref, defineEmits, nextTick } from "vue"
import EditTransaction from "@/app/components/transactions/EditTransaction.vue";
const show = ref(false)
const emit = defineEmits(['transaction-added']);

async function handleSaved(result) {
  show.value = false;
  await nextTick()
  // Emit to parent component
  emit('transaction-added', result);
}

</script>

<style lang="scss" scoped>

</style>
